import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import GraphQlConnection from '@/api/graph/GraphQlConnection';
import Page from '@/api/graph/Page';

export default function mapConnectionToPage<T>(
    observable: Observable<GraphQlConnection<T> | null>,
): Observable<Page<T> | null> {
    return observable.pipe(
        map((connection) =>
            connection
                ? {
                      nodes: connection.edges!.map((edge: any) => edge.node)!,
                      endCursor: connection.pageInfo!.endCursor!,
                      totalNodeCount: connection.pageInfo!.totalNodeCount!,
                      totalPageCount: connection.pageInfo!.totalPageCount!,
                  }
                : null,
        ),
    );
}
